import objectHash from 'object-hash';
import * as THREE from 'three';
import tokenize from 'glsl-tokenizer';
import stringify from 'glsl-token-string';
import tokenFunctions from 'glsl-token-functions';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var keywords = {
  position: 'csm_Position',
  positionRaw: 'csm_PositionRaw',
  pointSize: 'csm_PointSize',
  fragColor: 'csm_FragColor',
  // PBR
  diffuseColor: 'csm_DiffuseColor',
  // Color + alpha
  normal: 'csm_Normal',
  // Normal
  roughness: 'csm_Roughness',
  // Roughness
  metalness: 'csm_Metalness',
  // Metalness
  emissive: 'csm_Emissive',
  // Emissive
  ao: 'csm_AO' // AO

};

var _defaultPatchMap, _shaderMaterial_Patch;
var defaultPatchMap = (_defaultPatchMap = {}, _defineProperty(_defaultPatchMap, "".concat(keywords.normal), {
  '#include <beginnormal_vertex>': "\n    vec3 objectNormal = ".concat(keywords.normal, ";\n    #ifdef USE_TANGENT\n\t    vec3 objectTangent = vec3( tangent.xyz );\n    #endif\n    ")
}), _defineProperty(_defaultPatchMap, "".concat(keywords.position), {
  '#include <begin_vertex>': "\n    vec3 transformed = ".concat(keywords.position, ";\n  ")
}), _defineProperty(_defaultPatchMap, "".concat(keywords.positionRaw), {
  '#include <begin_vertex>': "\n    vec4 csm_positionUnprojected = ".concat(keywords.positionRaw, ";\n    mat4x4 csm_unprojectMatrix = projectionMatrix * modelViewMatrix;\n    #ifdef USE_INSTANCING\n      csm_unprojectMatrix = csm_unprojectMatrix * instanceMatrix;\n    #endif\n    csm_positionUnprojected = inverse(csm_unprojectMatrix) * csm_positionUnprojected;\n    vec3 transformed = csm_positionUnprojected.xyz;\n  ")
}), _defineProperty(_defaultPatchMap, "".concat(keywords.pointSize), {
  'gl_PointSize = size;': "\n    gl_PointSize = ".concat(keywords.pointSize, ";\n    ")
}), _defineProperty(_defaultPatchMap, "".concat(keywords.diffuseColor), {
  '#include <color_fragment>': "\n    #include <color_fragment>\n    diffuseColor = ".concat(keywords.diffuseColor, ";\n  ")
}), _defineProperty(_defaultPatchMap, "".concat(keywords.fragColor), {
  '#include <dithering_fragment>': "\n    #include <dithering_fragment>\n    gl_FragColor  = ".concat(keywords.fragColor, ";\n  ")
}), _defineProperty(_defaultPatchMap, "".concat(keywords.emissive), {
  'vec3 totalEmissiveRadiance = emissive;': "\n    vec3 totalEmissiveRadiance = ".concat(keywords.emissive, ";\n    ")
}), _defineProperty(_defaultPatchMap, "".concat(keywords.roughness), {
  '#include <roughnessmap_fragment>': "\n    #include <roughnessmap_fragment>\n    roughnessFactor = ".concat(keywords.roughness, ";\n    ")
}), _defineProperty(_defaultPatchMap, "".concat(keywords.metalness), {
  '#include <metalnessmap_fragment>': "\n    #include <metalnessmap_fragment>\n    metalnessFactor = ".concat(keywords.metalness, ";\n    ")
}), _defineProperty(_defaultPatchMap, "".concat(keywords.ao), {
  '#include <aomap_fragment>': "\n    #include <aomap_fragment>\n    reflectedLight.indirectDiffuse *= 1. - ".concat(keywords.ao, ";\n    ")
}), _defaultPatchMap);
var shaderMaterial_PatchMap = (_shaderMaterial_Patch = {}, _defineProperty(_shaderMaterial_Patch, "".concat(keywords.position), {
  'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );': "\n    gl_Position = projectionMatrix * modelViewMatrix * vec4( ".concat(keywords.position, ", 1.0 );\n  ")
}), _defineProperty(_shaderMaterial_Patch, "".concat(keywords.positionRaw), {
  'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );': "\n    gl_Position = ".concat(keywords.position, ";\n  ")
}), _defineProperty(_shaderMaterial_Patch, "".concat(keywords.diffuseColor), {
  'gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );': "\n    gl_FragColor = ".concat(keywords.diffuseColor, ";\n  ")
}), _defineProperty(_shaderMaterial_Patch, "".concat(keywords.fragColor), {
  'gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );': "\n    gl_FragColor = ".concat(keywords.fragColor, ";\n  ")
}), _shaderMaterial_Patch);

var defaultDefinitions =
/* glsl */
"\n\n#ifdef IS_VERTEX\n    vec3 csm_Position = position;\n    vec4 csm_PositionRaw = projectionMatrix * modelViewMatrix * vec4(position, 1.);\n    vec3 csm_Normal = normal;\n#else\n    #if defined IS_SHADERMATERIAL || defined IS_MESHDEPTHMATERIAL || defined IS_MESHNORMALMATERIAL\n        vec4 csm_DiffuseColor = vec4(1., 0., 1., 1.);\n        vec4 csm_FragColor = vec4(1., 0., 1., 1.);\n    #else\n        #if defined IS_MESHSTANDARDMATERIAL || defined IS_MESHPHYSICALMATERIAL\n            vec3 csm_Emissive = emissive;\n            float csm_Roughness = roughness;\n            float csm_Metalness = metalness;\n            float csm_AO = 0.;\n        #endif\n        \n        #ifdef USE_MAP\n            vec4 _csm_sampledDiffuseColor = texture2D(map, vUv);\n\n            #ifdef DECODE_VIDEO_TEXTURE\n            // inline sRGB decode (TODO: Remove this code when https://crbug.com/1256340 is solved)\n            _csm_sampledDiffuseColor = vec4(mix(pow(_csm_sampledDiffuseColor.rgb * 0.9478672986 + vec3(0.0521327014), vec3(2.4)), _csm_sampledDiffuseColor.rgb * 0.0773993808, vec3(lessThanEqual(_csm_sampledDiffuseColor.rgb, vec3(0.04045)))), _csm_sampledDiffuseColor.w);\n            #endif\n\n            vec4 csm_DiffuseColor = vec4(diffuse, opacity) * _csm_sampledDiffuseColor;\n            vec4 csm_FragColor = vec4(diffuse, opacity) * _csm_sampledDiffuseColor;\n        #else\n            vec4 csm_DiffuseColor = vec4(diffuse, opacity);\n            vec4 csm_FragColor = vec4(diffuse, opacity);\n        #endif\n    #endif\n#endif\n";

var _excluded = ["baseMaterial", "fragmentShader", "vertexShader", "uniforms", "patchMap", "cacheKey"];

var replaceAll = function replaceAll(str, find, rep) {
  return str.split(find).join(rep);
};

var escapeRegExpMatch = function escapeRegExpMatch(s) {
  return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
};

var isExactMatch = function isExactMatch(str, match) {
  return new RegExp("\\b".concat(escapeRegExpMatch(match), "\\b")).test(str);
}; // Hacky, yikes!


function isConstructor(f) {
  try {
    // @ts-ignore
    new f();
  } catch (err) {
    if (err.message.indexOf('is not a constructor') >= 0) {
      return false;
    }
  }

  return true;
}

function copyObject(target, source) {
  Object.assign(target, source);
  var proto = Object.getPrototypeOf(source);
  Object.entries(Object.getOwnPropertyDescriptors(proto)).filter(function (e) {
    return typeof e[1].get === 'function' && e[0] !== '__proto__';
  }).forEach(function (val) {
    Object.defineProperty(target, val[0], val[1]);
  });
}

var CustomShaderMaterial = /*#__PURE__*/function (_THREE$Material) {
  _inherits(CustomShaderMaterial, _THREE$Material);

  var _super = _createSuper(CustomShaderMaterial);

  function CustomShaderMaterial(_ref) {
    var _this;

    var baseMaterial = _ref.baseMaterial,
        fragmentShader = _ref.fragmentShader,
        vertexShader = _ref.vertexShader,
        uniforms = _ref.uniforms,
        patchMap = _ref.patchMap,
        cacheKey = _ref.cacheKey,
        opts = _objectWithoutProperties(_ref, _excluded);

    _classCallCheck(this, CustomShaderMaterial);

    var base;

    if (isConstructor(baseMaterial)) {
      base = new baseMaterial(opts);
    } else {
      base = baseMaterial;
      Object.assign(base, opts);
    }

    if (base.type === 'RawShaderMaterial') {
      throw new Error('CustomShaderMaterial does not support RawShaderMaterial');
    }

    _this = _super.call(this);
    copyObject(_assertThisInitialized(_this), base);
    _this.__csm = {
      patchMap: patchMap || {},
      fragmentShader: fragmentShader || '',
      vertexShader: vertexShader || '',
      cacheKey: cacheKey,
      baseMaterial: baseMaterial,
      instanceID: THREE.MathUtils.generateUUID(),
      type: base.type
    };
    _this.uniforms = _objectSpread2(_objectSpread2({}, _this.uniforms || {}), uniforms || {});
    {
      var _this$__csm = _this.__csm,
          _fragmentShader = _this$__csm.fragmentShader,
          _vertexShader = _this$__csm.vertexShader;
          _this$__csm.instanceID;
      var _uniforms = _this.uniforms;

      _this.generateMaterial(_fragmentShader, _vertexShader, _uniforms);
    }
    return _this;
  }

  _createClass(CustomShaderMaterial, [{
    key: "update",
    value: function update() {
      var _opts$cacheKey;

      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.uniforms = opts.uniforms || this.uniforms;
      copyObject(this.__csm, opts);
      var _this$__csm2 = this.__csm,
          fragmentShader = _this$__csm2.fragmentShader,
          vertexShader = _this$__csm2.vertexShader,
          instanceID = _this$__csm2.instanceID;
      var uniforms = this.uniforms;
      var serializedUniforms = Object.values(uniforms).reduce(function (prev, _ref2) {
        var value = _ref2.value;
        return prev + JSON.stringify(value);
      }, '');
      this.uuid = (opts === null || opts === void 0 ? void 0 : (_opts$cacheKey = opts.cacheKey) === null || _opts$cacheKey === void 0 ? void 0 : _opts$cacheKey.call(opts)) || objectHash([fragmentShader, vertexShader, serializedUniforms, instanceID]);
      this.generateMaterial(fragmentShader, vertexShader, uniforms);
    }
  }, {
    key: "clone",
    value: function clone() {
      var opts = {
        baseMaterial: this.__csm.baseMaterial,
        fragmentShader: this.__csm.fragmentShader,
        vertexShader: this.__csm.vertexShader,
        uniforms: this.uniforms,
        patchMap: this.__csm.patchMap,
        cacheKey: this.__csm.cacheKey
      };
      var clone = new this.constructor(opts);
      Object.assign(this, clone);
      return clone;
    }
  }, {
    key: "generateMaterial",
    value: function generateMaterial(fragmentShader, vertexShader, uniforms) {
      var _this2 = this;

      var parsedFragmentShader = this.parseShader(fragmentShader);
      var parsedVertexShader = this.parseShader(vertexShader);
      this.uniforms = uniforms || {};

      this.customProgramCacheKey = function () {
        return _this2.uuid;
      };

      this.onBeforeCompile = function (shader) {
        if (parsedFragmentShader) {
          var patchedFragmentShader = _this2.patchShader(parsedFragmentShader, shader.fragmentShader);

          shader.fragmentShader = _this2.getMaterialDefine() + patchedFragmentShader;
        }

        if (parsedVertexShader) {
          var patchedVertexShader = _this2.patchShader(parsedVertexShader, shader.vertexShader);

          shader.vertexShader = '#define IS_VERTEX;\n' + patchedVertexShader;
          shader.vertexShader = _this2.getMaterialDefine() + shader.vertexShader;
        }

        shader.uniforms = _objectSpread2(_objectSpread2({}, shader.uniforms), _this2.uniforms);
        _this2.uniforms = shader.uniforms;
      };

      this.needsUpdate = true;
    }
  }, {
    key: "getMaterialDefine",
    value: function getMaterialDefine() {
      return "#define IS_".concat(this.__csm.type.toUpperCase(), ";\n");
    }
  }, {
    key: "getPatchMapForMaterial",
    value: function getPatchMapForMaterial() {
      switch (this.__csm.type) {
        case 'ShaderMaterial':
          return shaderMaterial_PatchMap;

        default:
          return defaultPatchMap;
      }
    }
  }, {
    key: "patchShader",
    value: function patchShader(customShader, shader) {
      var patchedShader = shader;

      var patchMap = _objectSpread2(_objectSpread2({}, this.getPatchMapForMaterial()), this.__csm.patchMap);

      Object.keys(patchMap).forEach(function (name) {
        Object.keys(patchMap[name]).forEach(function (key) {
          if (name === '*' || isExactMatch(customShader.main, name)) {
            patchedShader = replaceAll(patchedShader, key, patchMap[name][key]);
          }
        });
      });
      patchedShader = patchedShader.replace('void main() {', "\n          ".concat(customShader.header, "\n          void main() {\n            ").concat(defaultDefinitions, "\n            ").concat(customShader.main, "\n          "));
      patchedShader = customShader.defines + patchedShader;
      return patchedShader;
    }
  }, {
    key: "parseShader",
    value: function parseShader(shader) {
      if (!shader) return; // Strip comments

      var s = shader.replace(/\/\*\*(.*?)\*\/|\/\/(.*?)\n/gm, '');
      var tokens = tokenize(s);
      var funcs = tokenFunctions(tokens);
      var mainIndex = funcs.map(function (e) {
        return e.name;
      }).indexOf('main');
      var variables = stringify(tokens.slice(0, mainIndex >= 0 ? funcs[mainIndex].outer[0] : undefined));
      var mainBody = mainIndex >= 0 ? this.getShaderFromIndex(tokens, funcs[mainIndex].body) : '';
      return {
        defines: '',
        header: variables,
        main: mainBody
      };
    }
  }, {
    key: "getShaderFromIndex",
    value: function getShaderFromIndex(tokens, index) {
      return stringify(tokens.slice(index[0], index[1]));
    }
  }]);

  return CustomShaderMaterial;
}(THREE.Material);

export { CustomShaderMaterial as default };
